import { OrderedMap } from 'immutable';

export const DATE_FILTER = 'date';
export const TEAM_FILTER = 'teams';
export const STATUS_FILTER = 'status';
export const FILTERS_MAP = OrderedMap({
  [STATUS_FILTER]: 'Status',
  build: 'Builds',
  os: 'OS',
  device: 'Device',
  owner: 'Owner',
  team: 'Team',
});

export const FILTER_KEY_MAP = Object.freeze({
  os: 'os',
  build_name: 'build',
  device: 'device',
});

export const OS_PREFIX_MAP = Object.freeze({
  ANDROID: 'Android',
  IOS: 'Ios',
});

export const FILTER_DEFAULT_ITEMS = Object.freeze({
  status: ['Passed', 'Failed', 'Complete', 'Error', 'In Progress', 'Queued'],
});
